import { useState } from 'react';
import { useMyAuctions } from '@/hooks/useUser';
import { Tabs } from '@/components/ui/Tabs';
import { AuctionRow } from '@/components/auction/AuctionRow';
import { Skeleton } from '@/components/ui/Skeleton';
import { EmptyState } from '@/components/common/EmptyState';
import { Button } from '@/components/ui/Button';
import { Link } from 'react-router-dom';
import styles from './MyAuctionsPage.module.css';

type TabValue = 'active' | 'participating' | 'won' | 'pending' | 'archived';

const TABS: { value: TabValue; label: string }[] = [
  { value: 'active', label: 'Мои активные' },
  { value: 'participating', label: 'Участвую' },
  { value: 'won', label: 'Выигранные' },
  { value: 'pending', label: 'На модерации' },
  { value: 'archived', label: 'Завершённые' },
];

export const MyAuctionsPage = () => {
  const [tab, setTab] = useState<TabValue>('active');
  const { data, isLoading } = useMyAuctions(tab);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <p className={styles.eyebrow}>Личный кабинет</p>
          <h1 className={styles.title}>Мои аукционы</h1>
        </div>
      </header>

      <div className={styles.tabsWrap}>
        <Tabs value={tab} onChange={setTab} tabs={TABS} />
      </div>

      <div className={styles.content}>
        {isLoading ? (
          <div className={styles.list}>
            <Skeleton height={96} />
            <Skeleton height={96} />
            <Skeleton height={96} />
          </div>
        ) : !data || data.length === 0 ? (
          <EmptyState
            title={emptyTitle(tab)}
            description={emptyDescription(tab)}
            action={
              tab === 'active' || tab === 'pending' ? (
                <Link to="/create">
                  <Button>Создать аукцион</Button>
                </Link>
              ) : (
                <Link to="/">
                  <Button variant="secondary">К ленте</Button>
                </Link>
              )
            }
          />
        ) : (
          <div className={styles.list}>
            {data.map((auction) => (
              <AuctionRow key={auction.id} auction={auction} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const emptyTitle = (tab: TabValue): string => {
  switch (tab) {
    case 'active': return 'Нет активных аукционов';
    case 'participating': return 'Ты не участвуешь';
    case 'won': return 'Пока без побед';
    case 'pending': return 'Ничего на модерации';
    case 'archived': return 'Архив пустой';
  }
};

const emptyDescription = (tab: TabValue): string => {
  switch (tab) {
    case 'active': return 'Создай свой первый аукцион';
    case 'participating': return 'Найди интересный лот и сделай ставку';
    case 'won': return 'Делай ставки и выигрывай';
    case 'pending': return 'Здесь будут аукционы, ожидающие модерации';
    case 'archived': return 'Сюда попадают завершённые твои аукционы';
  }
};